import React, { useEffect, useState } from 'react'
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { useFormik } from "formik";
import * as Yup from "yup";
import PageLoader from "../../componenets/PageLoader";
import { getAllQuiz, addQuiz } from '../../services/data/quiz';
import { useNavigate } from 'react-router-dom';

const QuizModal = ({show, handleClose}) => {
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)
    const [questions, setQuestions] = useState([])
    // console.log(questions, 'api')

    // Fixed: Store just the option ID, not an object
    const initialValues = questions.reduce((acc, question) => {
        acc[`question_${question.id}`] = '';
        return acc;
    }, {});

    // console.log('initial', initialValues);
   
    // Fixed: Validate as string (option ID)
    const quizSchema = Yup.object().shape(
        questions.reduce((acc, question) => {
            // acc[`question_${question.id}`] = Yup.string().required(`Please select an answer for question ${question.id}`);
            acc[`question_${question.id}`] = Yup.string().required(`Please select an answer for this question`);
            return acc;
        }, {})
    );
    
    const {
        values,
        handleBlur,
        handleChange,
        handleSubmit,
        handleReset,
        errors,
        touched,
    } = useFormik({
        initialValues: initialValues,
        validationSchema: quizSchema,
        enableReinitialize: true,
        onSubmit: async (values) => {      
            setLoading(true)            
            // console.log(values)
            // console.log(Object.entries(values))        
            // // Transform to the required format
            const dataFormat = Object.entries(values).map(([key, choosed_option]) => ({
                question: parseInt(key.split('_')[1]),
                option_choosed: parseInt(choosed_option)
            }));
            const payload = {
                answers : [
                    ...dataFormat
                ]
            }
            
          await addQuiz(payload).then((response)=>{              
            if(response.data.status === 'pass'){
                toast.success(response?.data?.message || 'You won! Proceed to the next round.')
                handleClose()
                navigate('/wheel/success')
            }else if(response.data.status === 'fail'){                
                toast.error(response?.data?.message || 'Better Luck Next Time!!!')
                handleClose()
                navigate('/quiz')
            }else{
                toast.error(response?.data?.message)
            }
          })
          .catch((err)=>{
            toast.error('Some error occured')
          })
          .finally(()=>{
            setLoading(false)
          })                                             
        },
    });

    // Fixed: Removed questions from dependency array to prevent infinite loop
    useEffect(() => {
        setLoading(true)
        getAllQuiz().then((response) => {
            if(response.data.status === 'success'){                
                setQuestions(response?.data?.data)
            } else {
                toast.error(response?.data?.message)
            }
        })
        .catch((error) => {
            console.error(error)
            toast.error("Some error occurred")
        })
        .finally(() => {
            setLoading(false)
        })
    }, [])

    return (
         <div>
            <Modal 
                show={show} 
                onHide={handleClose} 
                size="lg"
                centered         
            >
                { loading ? <PageLoader loading="Loading..."/> : (
                    <form 
                        onSubmit={handleSubmit}
                        className="justify-content-center"
                    >
                        <Modal.Header 
                            closeButton 
                            style={{
                                backgroundColor:"#dcedc8"
                            }}              
                        >          
                            <Modal.Title><b>Quiz Time</b></Modal.Title>
                        </Modal.Header>
                        
                        <Modal.Body 
                            style={{
                                backgroundColor:'#f4faed',
                                maxHeight: '500px',
                                overflowY: 'auto'
                            }}
                        >
                            <div className="container-fluid"  
                                style={{
                                    backgroundColor:'#f4faed'
                                }} 
                            >
                                {questions.map((question, index) => (
                                    <div key={question.id} className="row mb-4">
                                        <div className='col-12'>
                                            <div className="form-group">
                                                <label htmlFor={`question_${question.id}`}>
                                                    <b>Question {index + 1}:</b> 
                                                    <br/>
                                                    {question.question}
                                                </label>
                                                <br />                                                
                                                {question.options.map((option, optIndex) => {
                                                    const optionValue = String.fromCharCode(97 + optIndex);
                                                    return (
                                                        <div key={option.id} className="form-check">
                                                            <input
                                                                className="form-check-input"
                                                                type="radio"
                                                                name={`question_${question.id}`}
                                                                id={`question_${question.id}_${optionValue}`}
                                                                value={option.id}
                                                                checked={values[`question_${question.id}`] === String(option.id)}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                            />
                                                            <label 
                                                                className="form-check-label" 
                                                                htmlFor={`question_${question.id}_${optionValue}`}
                                                            >
                                                                {optionValue.toUpperCase()}. {option.option}
                                                            </label>
                                                        </div>
                                                    );
                                                })}
                                                
                                                {errors[`question_${question.id}`] && touched[`question_${question.id}`] && (
                                                    <div className="text-danger mt-1">
                                                        <small>{errors[`question_${question.id}`]}</small>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        {index < questions.length - 1 && <hr />}
                                    </div>
                                ))}
                            </div>
                        </Modal.Body>
                        
                        <Modal.Footer 
                            className="d-flex flex-row justify-content-center"
                            style={{
                                backgroundColor:'#f4faed'
                            }}
                        >          
                            <button
                                type="reset"
                                className="btn btn-warning"
                                onClick={handleReset}
                            >
                                Reset
                            </button>
                            <button
                                type="submit"
                                className="btn btn-primary"              
                            >
                                Submit Quiz
                            </button> 
                            <button
                                type="button"
                                className="btn btn-danger" 
                                onClick={() => {handleClose()}}
                            >
                                Cancel
                            </button>          
                        </Modal.Footer>   
                    </form> 
                )} 
            </Modal>
        </div>
    )
}

export default QuizModal